import { Controller } from '@hotwired/stimulus';
import { DEFAULT_TIMEOUT } from 'lib/constants';

export default class extends Controller {
  static targets = ['message'];

  initialize() {
    this.timeout = null;
  }

  connect() {
    // Automatically remove success messages after a timeout
    if (this.hasMessageTarget && this.messageTarget?.classList?.contains('flash-success')) {
      this.timeout = setTimeout(() => {
        this.element.remove();
      }, DEFAULT_TIMEOUT);
    }
  }

  disconnect() {
    clearTimeout(this.timeout);
  }

  dismiss(event) {
    clearTimeout(this.timeout);
    event.currentTarget.closest('.flash').remove();
  }
}
